// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","108":"f03079819f8757c97349","243":"307c1cf31df043fbcfea","615":"d7bc330c852117fef906","682":"010d3484390bfdcb1778","688":"68ade61144ac6cd25377","852":"f7674fcc58a539abfecd"}[chunkId] + ".bundle.js";
};